import React, { useLayoutEffect } from 'react';
import { useAsyncValue, useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

// Styles
import { Container } from './styles';

// Components
import { GridOfPhotos } from '../../../../../../components/multimedia/GridOfPhotos';

// Types
import { LoaderMultimedia } from './types';

// Redux
import { roidOTSelected } from '../../../../../../state/actions/ui/roidOTSelectedGeneralView';
import { OrderType } from '../../../../../../types/orders';

export const MultimediaGridGeneralView = (): JSX.Element => {
  const loaderData = useAsyncValue() as LoaderMultimedia;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // La ruta es `multimedia/:id` y ese id es el de la fila que se abrió.
  const { id } = useParams();

  useLayoutEffect(() => {
    if (!loaderData) navigate('..');
    dispatch(
      roidOTSelected(
        OrderType.Multimedia,
        Array.isArray(loaderData.images[0].roid)
          ? loaderData.images[0].roid.join('.')
          : loaderData.images[0].roid,
        // El id dice A QUÉ pertenece el ROID, y aquí se mandaba el
        // `orderIDs[0]` de la PRIMERA foto — que no tiene por qué ser la
        // entidad abierta: una imagen puede colgar de varias órdenes. Como
        // nadie lo comprobaba, el desajuste no se veía; en cuanto la miga
        // empezó a exigir que el ROID fuera de la ruta actual, esta pantalla
        // se quedaba con la marca de posición para siempre. El resto de sitios
        // (incluido el otro grid de multimedia) ya mandan el id de la URL.
        id as string
      )
    );
  }, [loaderData, id]);

  return (
    <Container>
      <GridOfPhotos imagesToShow={loaderData.images} />
    </Container>
  );
};
